module.exports = __webpack_public_path__ + "static/media/ready.01945cd5.svg";